import React, { ReactNode } from "react";
import classNames from "classnames";

import {
  ComponentElementsParagraph,
  Enum_Componentelementsparagraph_Size,
} from "../../../graphql/generated/graphql";

export type IParagraph = Omit<ComponentElementsParagraph, "id" | "size"> & {
  children?: ReactNode;
  containerClassName?: string;
  paragraphClassName?: string;
  size?: Enum_Componentelementsparagraph_Size;
};

export function Paragraph({
  size = Enum_Componentelementsparagraph_Size.Normal,
  text,
  children,
  containerClassName = "prose",
  paragraphClassName = "",
}: IParagraph): JSX.Element {
  return (
    <div className={containerClassName}>
      <p
        className={classNames({
          "text-base": size === Enum_Componentelementsparagraph_Size.Normal,
          "text-xs": size === Enum_Componentelementsparagraph_Size.Tiny,
          "text-sm": size === Enum_Componentelementsparagraph_Size.Small,
          "text-lg": size === Enum_Componentelementsparagraph_Size.Large,
          [paragraphClassName]: Boolean(paragraphClassName),
        })}
      >
        <>{text && text}</>
        <>{children && children}</>
      </p>
    </div>
  );
}
